import React, { Component } from 'react';
import PropTypes from 'prop-types';

import api from "../../../api";
import { format, formatCurrency } from '../../../functions/functions';
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: "",     
            simbolo: "",     
            cotizacion_pesos: "0,00", 
            postVariables: ['nombre', 'simbolo', 'cotizacion_pesos'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        onClose: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'EDIT_COTIZACION', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            nombre: "",
            simbolo: "",
            cotizacion_pesos: "0,00", 
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(campo => {
            data[campo] = this.state[campo];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                nombre: data.nombre,
                simbolo: data.simbolo,
                cotizacion_pesos: data.cotizacion_pesos, 
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Moneda",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Moneda ha sido creada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",

                disabled: false,
                isNombreDisabled: false,
                isSimboloDisabled: false,
            };
        } else if (action == "EDIT") {
            return {
                id: this.props.id,
                get: true,
                submitType: "PUT",
                title: "Editar Moneda",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Moneda ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",

                disabled: false,
                isNombreDisabled: false,
                isSimboloDisabled: false,
            };
        } else if (action == "EDIT_COTIZACION") {
            return {
                id: this.props.id,
                get: true,
                submitType: "PUT",
                title: "Editar Moneda",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Moneda ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",

                disabled: false,
                isNombreDisabled: true,
                isSimboloDisabled: true,
            };
        } else if (action == "DETAIL") {
            return {
                id: this.props.id,
                get: true,
                submitType: null,
                title: "Moneda",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",

                disabled: true,
                isNombreDisabled: true,
                isSimboloDisabled: true,
            };
        } else if (action == "DELETE") {
            return {
                id: this.props.id,
                get: true,
                submitType: "DELETE",
                title: "Eliminar Moneda",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Moneda ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",

                disabled: true,
                isNombreDisabled: true,
                isSimboloDisabled: true,
            };
        }
    }

    onClose(){
        if (this.props.onClose){ // Ejecutar funcion de cerrar del componente padre si es que existe
            this.props.onClose();
        }

        this.resetForm();
    }

    render() {
        const { nombre, simbolo, cotizacion_pesos  } = this.state;
        let vars = this.modalVars();

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.monedas.monedas : null)}
                submitUrl={(vars.submitType ? api.monedas.monedas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.onClose()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                className="ui-paradigma-modal"
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la moneda</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={vars.isNombreDisabled}
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            maxLength={150}
                            label={"Nombre"}
                            value={nombre}
                            onChange={(e) => this.onChangeField('nombre', e.target.value)}
                            error={() => this.getError('nombre')}
                        />

                        <ParadigmaLabeledInput
                            disabled={vars.isSimboloDisabled}
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            maxLength={150}
                            label={"Símbolo"}
                            value={simbolo}
                            onChange={(e) => this.onChangeField('simbolo', e.target.value)}
                            error={() => this.getError('simbolo')}
                        />

                        <div className="ui-form-grid">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Cotización (Pesos)"}
                                error={() => this.getError('cotizacion_pesos')}
                                inputComponent={
                                    <ParadigmaCurrencyInput
                                        disabled={vars.disabled}
                                        className="form-control monto w-100"
                                        symbol={"$"}
                                        value={formatCurrency(cotizacion_pesos)}
                                        onChange={data => this.onChangeField('cotizacion_pesos', data)}
                                    />
                                }
                            />
                        </div>
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Monedas/Monedas/Modal.js